import './index.scss'
import React, { useRef, useState, useEffect } from 'react'
import Loader from 'react-loaders'
import { AnimatedLetters } from '../../AnimatedLetters'
import emailjs from '@emailjs/browser'
import { TileLayer, Popup, Marker, MapContainer } from 'react-leaflet'

export const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    const refForm = useRef()

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 3000)

    }, [])

    const sendEmail = (e) => {
        e.preventDefault()

        emailjs.sendForm(
            'service_fe090ar',
            'template_6tp4fc9',
            refForm.current,
            'A-xvc60Z2C01RSFQE'
        ).then(
            () => {
                alert('Message successfully sent!')
                window.location.reload(false)
            },
            () => {
                alert('Failed to send the message')
            }
        )
    }

    return (
        <>
            <div className='container contact-page'>
                <div className='text-zone'>
                    <h1>
                        <AnimatedLetters letterClass={letterClass} strArray={'Contact  me'.split(' ')} idx={15} />
                    </h1>
                    <p>
                    Always open to interesting suggestions and just fun questions :)
                    </p>
                    <div className='contact-form'>
                        <form ref={refForm} onSubmit={sendEmail} >
                            <ul>
                                <li className='half'>
                                    <input type="text" name="from_name" placeholder='Name' required />
                                </li>
                                <li className='half'>
                                    <input type="email" name="email" placeholder='Email' required />
                                </li>
                                <li>
                                    <input type="text" name="subject" placeholder='Subject' required />
                                </li>
                                <li>
                                    <textarea placeholder="Message" name="message" required></textarea>
                                </li>
                                <li>
                                    <input type="submit" className='flat-button' value="SEND" />
                                </li>

                            </ul>
                        </form>

                    </div>
                </div>
                <div className='info-map'>
                    Alex St,
                    <br/>
                    Russia,
                    <br/>
                    Yekaterinburg
                    <span>stihinaleksander@yandex.ru</span>
                </div>
                <div className='map-wrap'>
                    <MapContainer center={[56.832708, 60.596577]} zoom={6}>
                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                        <Marker position={[56.832708, 60.596577]}>
                            <Popup>Living Ural :)</Popup>
                        </Marker>
                    </MapContainer>
                </div>
            </div>
            <Loader type='pacman' />
        </>
    )
}
